import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

/**
 * Milliseconds left until `expiresAt`, floored at 0. Returns null when there is no deadline.
 */
export const getRemainingTime = (expiresAt?: string) => {
  if (!expiresAt) {
    return null;
  }

  return Math.max(dayjs(expiresAt).diff(), 0);
};

/**
 * Formats a millisecond duration as a `m:ss` countdown, e.g. 65_000 -> "1:05".
 *
 * Rounds up to the next whole second before formatting so a fresh session reads
 * "15:00" (not "14:59") and the last second reads "0:01" until it truly hits zero.
 * dayjs handles the formatting; only the rounding policy stays here.
 */
export const formatRemainingTime = (remainingTime: number) =>
  dayjs.duration(Math.ceil(remainingTime / 1000) * 1000).format('m:ss');
